import React from "react";
import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import {
  toFileKey,
  uploadToS3 as uploadFileWithPresigned,
} from "shared/api/awsS3";
import { createPopup, getPopup, updatePopup } from "shared/api/PopupApi";
import { usePostingPeriod } from "shared/lib/date/usePostingPeriod";
import CircularProgressIndicator from "shared/ui/CircularProgressIndicator";
import { alertDialog, confirmDialog, confirmLeaveIfDirty } from "shared/ui/feedback";
import { ChipGroup } from "shared/ui/filters";
import { DateInput as BaseDateInput } from "shared/ui/inputs";
import { FormPageShell } from "shared/ui/layout";
import { ImageUploadBox } from "shared/ui/upload";
const DateInput3 = styled(BaseDateInput)`
  width: 120px;
  margin-right: 16px;
`;
const DateInput4 = styled(BaseDateInput)`
  width: 120px;
  margin-right: 16px;
`;
const DateInput2 = styled(BaseDateInput)`
  margin-right: 16px;
`;
const DDiv = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;
`;
const Pubp1 = styled.header`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 30px;
  // font-family: "NotoSansKR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400; //${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;
const Pubp = styled.header`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 30px;
  //font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  color: var(--text-black, #111);
  /* Admin/Body/B1-16 R */
  //font-family: "NotoSansKR";
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400; //${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;
const DateInput = styled(BaseDateInput)`
  margin-right: 16px;
  margin-left: -5px;
  /* Admin/Body/B1-16 R */
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
`;

const Shortline = styled.div`
  width: 10px;
  color: #000;
  text-align: center;
  //padding-right: 24px;
  margin-right: 12px;

  /* Admin/Body/B2-15 R */
  //font-family: "NotoSansKR";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 21px */
`;

const Datep = styled.header`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 30px;
  flex-shrink: 0;
  // font-family: "NotoSansKR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400; // ${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;
const Titlep = styled.header`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 30px;
  /* Admin/Body/B1-16 R */
  //font-family: "NotoSansKR";

  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400;
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;
const RegisterDiv = styled.div`
  display: flex;
  flex-direction: column;

  width: 97%;
  height: auto;
  padding: 20px 15px;
  gap: 15px;
  //background-color: red;
  border-radius: 4px;
  background: var(--white, #fff);
`;

const PopupContentsDiv = styled.div`
  display: flex;
  flex-direction: row;

  width: 97%;
  height: 240px;
  border-radius: 4px;
  //background: var(--white, #FFF);
  background-color: #fff;
  margin-top: 30px;
`;
const RowDiv3 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  // padding-left: 20px;
  margin-top: 10px;
`;
const Checked = styled.div`
  display: flex;
  flex-direction: row;
  width: 100px;
  height: 22px;
  margin-right: 30px;
  color: var(--text-black, #111);
  /* Admin/Body/B1-16 R */
  //font-family: "NotoSansKR";
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400; //${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;

const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //padding-left: 20px;
`;
const RowDiv1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //padding-left: 20px;
  margin-top: 5px;
`;
const RowDiv4 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  // padding-left: 20px;
  margin-top: 5px;
`;
const RowDiv2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //padding-left: 20px;
  //margin-top: 5px;
`;

const TextInput = styled.input`
  width: 472px;
  height: 35px;
  border-radius: 2px;
  border: 1px solid #e8e8e8;
  padding: 2px 10px;
  &::placeholder {
    opacity: 0.2;
  }
`;

const PopupImageSlot = styled.div`
  margin-left: 20px;
  margin-top: 20px;
`;
const FILELINK = styled.div`
  width: 500px;
  height: 114px;

  margin-left: 16px;
  margin-top: 20px;
`;
const BOXLink = styled.input`
  margin-left: 42px;
  width: 380px;
  height: 35px;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  background: var(--white, #fff);
  margin-top: 7px;
  &::placeholder {
    opacity: 0.2;
  }
`;
const LEtter2 = styled.div`
  width: 88px;
  height: 22px;
  margin-top: 13px;
  flex-shrink: 0;
  //font-family: "NotoSansKR";

  color: var(--text-black, #111);
  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body1};
  font-weight: 400; //${(props) => props.theme.fontWeights.Body1};
  line-height: ${(props) => props.theme.LineHeight.Body1};
`;
const ImgLink = styled.div`
  margin-top: 13px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  //background-color: red;
`;

const Reddot = styled.div`
  color: #ff1717;
  font-family: "NotoSansKR";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;

const PeriodToggleChip = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
`;

// 게시기간 설정 토글과 시작/종료 날짜·시간 입력을 감싼다.
// 폭이 좁아지면 좌측 '게시기간' 라벨은 그대로 두고 이 영역만 줄바꿈된다.
const PeriodControls = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 10px;
`;

// 날짜+시간을 한 쌍으로 묶어 줄바꿈 시 짝이 분리되지 않게 한다.
const DateTimePair = styled.div`
  display: inline-flex;
  align-items: center;
`;

function Popupregister() {
  const navigate = useNavigate();
  const { popupId } = useParams();
  const isEditMode = Boolean(popupId);

  const [file, setFile] = useState();

  const [imageUrl, setImageUrl] = useState();
  //imageurl

  const [imageLink, setImageLink] = useState("");
  // 입력되는 imageLink

  const [imageView, setImageView] = useState();

  const [title, setTitle] = useState("");
  // 제목 state

  const period = usePostingPeriod();
  const { start, end } = period;
  const [starttime, setstarttime] = useState(null);
  const [endtime, setendtime] = useState(null);

  // 게시 기간 토글: 끄면 날짜/시간을 모두 비운다.
  // 단, '예약'은 시작일이 필수라 게시기간을 끌 수 없다.
  const handlePeriodToggle = (checked) => {
    if (!checked && postok === 2) return;
    period.setEnabled(checked);
    if (!checked) {
      setstarttime(null);
      setendtime(null);
    }
  };

  // 게시 여부 변경. '예약'은 언제 게시할지 정하는 상태이므로 시작일 입력이
  // 필요하다 → 게시기간 영역을 자동으로 켜서 시작일을 넣게 한다.
  const handleStatusChange = (value) => {
    setpostok(value);
    if (value === 2) {
      period.setEnabled(true);
    }
  };

  const [isDesktop, setIsDesktop] = useState(true);
  // desktop true
  // 모바일 false

  const [isAllVisitors, setIsAllVisitors] = useState(true);
  // 적용조건 모든방문자 true, 로그인 방문자false

  const [postok, setpostok] = useState(0);

  // 1게시 2 예약 0 미게시

  const [isModalOpen, setIsModalOpen] = useState(false);

  // 입력된 내용이 있는지 (이전·취소 시 확인 모달 노출 여부 판단)
  const hasInput = Boolean(
    title ||
    imageView ||
    imageLink ||
    period.enabled ||
    period.start ||
    period.end ||
    starttime ||
    endtime,
  );

  // 이전(<)·취소 공용 핸들러: 입력 내용이 있을 때만 확인 모달을 띄운다.
  const handleLeave = async () => {
    const isConfirmed = await confirmLeaveIfDirty(
      hasInput,
      isEditMode
        ? "팝업 수정을 취소하시겠습니까?\n취소 시 수정 중인 내용이 사라집니다."
        : "팝업 등록을 취소하시겠습니까?\n취소 시 작성 중인 내용이 사라집니다.",
    );

    if (isConfirmed) {
      navigate("/main/popup");
    }
  };

  // 수정 모드: 기존 팝업 정보를 불러와 폼을 채운다.
  // (게시 기간 start/end는 "YYYY-MM-DD HH:MM:SS" 형태라 날짜/시간으로 분리)
  useEffect(() => {
    if (!isEditMode) return;
    let cancelled = false;
    (async () => {
      try {
        const data = await getPopup(popupId);
        if (cancelled || !data) return;
        setTitle(data.title ?? "");
        setImageUrl(data.image ?? "");
        setImageView(data.image ?? "");
        setImageLink(data.link ?? "");
        setIsDesktop(data.targetDevice !== false);
        setIsAllVisitors(data.targetVisitor !== false);
        // 서버는 hide + progressStatus로 응답한다(status 없음).
        // 게시 여부(0 미게시 / 1 게시 / 2 예약)는 이 둘로부터 역산한다.
        const derivedPostok = data.hide
          ? 0
          : data.progressStatus === "BEFORE"
            ? 2
            : 1;
        setpostok(derivedPostok);

        const [startDate, startClock] = String(data.start ?? "").split(" ");
        const [endDate, endClock] = String(data.end ?? "").split(" ");
        period.initialize(startDate || null, endDate || null);
        setstarttime(startClock ? startClock.slice(0, 5) : null);
        setendtime(endClock ? endClock.slice(0, 5) : null);
        // 예약 상태는 시작일 입력이 필요하므로 게시기간 영역을 켠 채로 둔다.
        if (derivedPostok === 2) {
          period.setEnabled(true);
        }
      } catch (error) {
        alertDialog("팝업 정보를 불러오지 못했습니다.");
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, popupId]);

  const convertToDatabaseFormat = (date) => {
    const parsedDate = new Date(date);
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");

    const hours = String(parsedDate.getHours()).padStart(2, "0");
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
    const seconds = String(parsedDate.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleRegisterClick = async () => {
    if (isModalOpen) {
      return; // 업로드/등록 진행 중이면 중복 실행 방지
    }

    // 시작/종료 "일시"(날짜+시간) 역전 검사. 둘 다 입력된 경우에만 검사한다
    // (예약은 종료가 없을 수 있음). 같은 날 시간 역전도 여기서 막는다.
    if (start && starttime && end && endtime) {
      const startDateTime = new Date(`${start}T${starttime}`);
      const endDateTime = new Date(`${end}T${endtime}`);
      if (endDateTime < startDateTime) {
        alertDialog("종료일시는 시작일시보다 이전일 수 없습니다.");
        return;
      }
    }

    const isConfirmed = await confirmDialog(
      isEditMode ? "팝업을 수정하시겠습니까?" : "팝업을 등록하시겠습니까?",
    );

    if (!isConfirmed) {
      return;
    }

    setIsModalOpen(true);
    try {
      // 이미지를 업로드하고 그 S3 key를 직접 받아 사용한다(상태는 비동기라 즉시 못 읽음).
      const uploadedImageKey = await uploadToS3();

      if (!uploadedImageKey) {
        alertDialog("이미지를 업로드해주세요.");
        setIsModalOpen(false);
        return;
      }

      // Proceed with registration
      const data = {
        title: title,
        //name: localStorage.getItem("userName"),
        imageKey: uploadedImageKey,
        targetDevice: isDesktop,
        targetVisitor: isAllVisitors,
        // 서버는 hide(숨김)로 노출을 판정한다. 미게시(0)만 숨김 처리하고,
        // 게시(1)/예약(2)의 구분은 게시기간(start/end→progressStatus)이 담당한다.
        hide: postok === 0,
        link: imageLink,
        start: start && starttime
          ? convertToDatabaseFormat(`${start} ${starttime}`)
          : null,
        end: end && endtime
          ? convertToDatabaseFormat(`${end} ${endtime}`)
          : null,
      };

      if (isEditMode) {
        await updatePopup(popupId, data);
      } else {
        await createPopup(data);
      }

      navigate("/main/popup");
    } catch (error) {
      alertDialog(
        isEditMode
          ? "팝업 수정에 실패했습니다. 잠시 후 다시 시도해주세요."
          : "팝업 등록에 실패했습니다. 잠시 후 다시 시도해주세요.",
      );
      // console.error("Error in handleRegisterClick:", error);
      setIsModalOpen(false);
    }
  };

  const handleSelectImage = (selectedFile) => {
    setFile(selectedFile);
    setImageView(URL.createObjectURL(selectedFile));
  };

  const handledeltedButtonClick = () => {
    setImageView(null);
  };

  // 공용 presigned 업로더로 이미지 업로드 후 S3 key를 반환한다(서버가 imageKey를 기대).
  // (상태(setImageUrl)는 비동기라 호출 직후 값을 못 읽으므로 반환값을 사용한다)
  // 재업로드 안 한 기존 이미지는 전체 URL(imageUrl)이라 key로 변환해 보낸다.
  const uploadToS3 = async () => {
    if (!file) {
      return imageUrl ? toFileKey(imageUrl) : null;
    }
    const uploaded = await uploadFileWithPresigned(file, true);
    const url = uploaded?.imageUrl || uploaded?.downloadLink || "";
    setImageUrl(url);
    return uploaded?.key || toFileKey(url) || "";
  };
  // 종료는 입력했다면 날짜+시간 짝이 맞아야 하고, 비우면 허용.
  const isEndPairOk = (!end && !endtime) || Boolean(end && endtime);
  // '예약'은 시작(날짜+시간) 필수, 종료는 선택.
  // 그 외에는 게시기간 사용 시 시작·종료 모두 필수(기존 규칙).
  const isPeriodComplete =
    postok === 2
      ? Boolean(start && starttime && isEndPairOk)
      : !period.enabled || Boolean(start && starttime && end && endtime);
  const isAllDataFilled = () => {
    return Boolean(title && imageView && isPeriodComplete);
  };
  const TitieChange = (e) => {
    if (e.target.value.length <= 50) {
      setTitle(e.target.value);
    }
  };

  return (
    <FormPageShell
      title={isEditMode ? "팝업 수정하기" : "팝업 등록하기"}
      onBack={handleLeave}
      submitLabel={isEditMode ? "수정하기" : "등록하기"}
      canSubmit={isAllDataFilled()}
      onSubmit={handleRegisterClick}
    >
      <CircularProgressIndicator loading={isModalOpen} msg="저장 중.." />
      <DDiv>
        <RegisterDiv>
          <RowDiv>
            <Titlep>
              팝업 타이틀<Reddot>&nbsp;*</Reddot>
            </Titlep>
            <TextInput
              type="text"
              placeholder="제목입력"
              value={title}
              onChange={TitieChange}
            />
          </RowDiv>
          <RowDiv1>
            <Pubp1>
              게시 여부<Reddot>&nbsp;*</Reddot>
            </Pubp1>
            <ChipGroup
              options={[
                { label: "게시", value: 1 },
                { label: "예약", value: 2 },
                { label: "미게시", value: 0 },
              ]}
              value={postok}
              onChange={handleStatusChange}
            />
          </RowDiv1>
          <RowDiv2>
            <Datep>
              게시기간{postok === 2 && <Reddot>&nbsp;*</Reddot>}
            </Datep>
            <PeriodControls>
              <PeriodToggleChip>
                <ChipGroup
                  options={[
                    { label: "게시 기간 설정", value: "on", disabled: postok === 2 },
                  ]}
                  value={period.enabled ? "on" : null}
                  onChange={(value) => handlePeriodToggle(value === "on")}
                />
              </PeriodToggleChip>
              <DateTimePair>
                <DateInput
                  type="date"
                  id="Sdate"
                  value={start ?? ""}
                  onChange={period.handleStartChange}
                  disabled={!period.enabled}
                  $default={!start}
                />
                <DateInput3
                  type="time"
                  id="Ssdate"
                  value={starttime ?? ""}
                  onChange={(e) => setstarttime(e.target.value)}
                  disabled={!period.enabled || !start}
                  $default={!starttime}
                />
              </DateTimePair>
              <Shortline style={{ opacity: period.enabled ? 1 : 0.2 }}>
                -
              </Shortline>
              <DateTimePair>
                <DateInput2
                  type="date"
                  id="Ddate"
                  value={end ?? ""}
                  onChange={period.handleEndChange}
                  disabled={!period.enabled || !start}
                  $default={!end}
                />
                <DateInput4
                  type="time"
                  id="Dddate"
                  value={endtime ?? ""}
                  onChange={(e) => setendtime(e.target.value)}
                  disabled={!period.enabled || !end}
                  $default={!endtime}
                />
              </DateTimePair>
            </PeriodControls>
          </RowDiv2>
          <RowDiv3>
            <Checked>
              대상 기기 <Reddot>&nbsp;*</Reddot>
            </Checked>
            <ChipGroup
              options={[
                { label: "데스크톱", value: true },
                { label: "모바일", value: false },
              ]}
              value={isDesktop}
              onChange={(value) => setIsDesktop(value)}
            />
          </RowDiv3>

          <RowDiv4>
            <Pubp>
              적용조건
              <Reddot>&nbsp;*</Reddot>
            </Pubp>

            <ChipGroup
              options={[
                { label: "모든 방문자", value: true },
                { label: "로그인 방문자", value: false },
              ]}
              value={isAllVisitors}
              onChange={(value) => setIsAllVisitors(value)}
            />
          </RowDiv4>
        </RegisterDiv>
        <PopupContentsDiv>
          <PopupImageSlot>
            <ImageUploadBox
              imageUrl={imageView}
              onSelectFile={handleSelectImage}
              onRemove={handledeltedButtonClick}
              title="팝업 이미지 삽입"
              sizeHint="이미지 사이즈(250*250 권장)"
              width="314px"
              height="200px"
            />
          </PopupImageSlot>
          <FILELINK>
            <ImgLink>
              <LEtter2>이미지 링크</LEtter2>
              <BOXLink
                type="text"
                placeholder="링크 입력"
                value={imageLink}
                onChange={(e) => setImageLink(e.target.value)}
              />
            </ImgLink>
          </FILELINK>
        </PopupContentsDiv>
        {/* ... */}
      </DDiv>
    </FormPageShell>
  );
}

export default Popupregister;
